import { FETCH_USER_CERTIFICATES, FETCH_INDIVIDUAL_CERTIFICATE, FETCH_USERS, FETCH_LEARNING_SESSION_DATA,USER_REGISTRATION, UPDATE_USER_STATUS ,ADD_USER, RESET_STATE, DELETE_USER, FETCH_INDIVIDUAL_USER, UPDATE_USER, UPLOAD_USERS_CSV, FETCH_USER_LOG } from "./actions.type";
import { SET_USER_CERTIFICATES, SET_USERS,SET_USER_STATUS ,SET_INDIVIDUAL_USER, SET_USER_LOG, SET_ERROR_USER, STATE_RESET, SET_LEARNING_SESSION_DATA} from "./mutations.type";
import { UsersService, LearningSessionService } from "@/common/api.service";

const initialState = () => {
    return {
    users: [],
    individualuser: [],
    response: null,
    usererrors: [],
    learningsessiondata:[],
    usercertificates:[],
    userlog:[],
    }
}

export const state = initialState()

const getters = {
    users(state) {
        return state.users
    },
    individualuser(state) {
        return state.individualuser
    },
    usercertificates(state) {
        return state.usercertificates
    },
    learningsessiondata(state) {
        return state.learningsessiondata
    },
    userlog(state) {
        return state.userlog
    },

};


const actions = {
    async [FETCH_USERS](context,slug) {
        const { data } = await UsersService.get(slug)
        context.commit(SET_USERS, data.data)
        return data;
    },
    async [FETCH_LEARNING_SESSION_DATA](context){
        const { data } = await LearningSessionService.get()
        context.commit(SET_LEARNING_SESSION_DATA, data.data)
        return data;
    },
    [USER_REGISTRATION](context, payload) {
        return UsersService.create(payload, 'register')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message)
        });
    }, 

    [ADD_USER](context, payload) {
        return UsersService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message)
        });
    }, 
    [UPLOAD_USERS_CSV](context, payload) {
        return UsersService.uploadCSV(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.message)
        });
    },   
    [DELETE_USER] (context, userid) {
        return UsersService.delete(userid)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.errors)
        });
    },
    [UPDATE_USER](context, payload) {
        return UsersService.create(payload, payload.user_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message)
        });
    }, 
    async [FETCH_INDIVIDUAL_USER](context, payload) {
        const { data } = await UsersService.get(payload)
        context.commit(SET_INDIVIDUAL_USER, data.data)
        return data; 
    }, 
    async [UPDATE_USER_STATUS] (context, payload) {
        const { data } = await UsersService.create(payload, payload.user_id)
        context.commit(SET_USER_STATUS, data.data)
        return data;         
    },
    async [FETCH_USER_CERTIFICATES](context,slug) {
        const { data } = await UsersService.get(slug)
        context.commit(SET_USER_CERTIFICATES, data.data)
        return data;
    },
    [FETCH_INDIVIDUAL_CERTIFICATE](context, payload) {
        return UsersService.get(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message)
        });
    }, 
    async [FETCH_USER_LOG](context, payload) {
        const { data } = await UsersService.getlog(payload)
        context.commit(SET_USER_LOG, data.data)
        return data; 
    }, 
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET)
    }      
};

const mutations = {
    [SET_ERROR_USER](state, error) {
        state.usererrors = error
    },    
    [SET_LEARNING_SESSION_DATA](state,sessiondata){
        state.learningsessiondata= sessiondata
    },
    [SET_USERS](state, users) {
        state.users = users
    },
    [SET_USER_CERTIFICATES](state, usercertificatesdata) {
        state.usercertificates = usercertificatesdata
    },
    [SET_INDIVIDUAL_USER](state, user) {
        state.individualuser = user
    },  
    [SET_USER_STATUS] (state,user){
        let id = state.users.findIndex(x => x.user_id === user.user_id)
        state.users[id] = user
    },  
    [SET_USER_LOG](state, log) {
        log.forEach(function (element) {
            element.color = element.log_type=='module'?'#808000':element.log_type=='quiz'?'#00897B':element.log_type=='group'?"#808080":element.log_type=='course'?'#008000':'#01579B';
            element.colorName = element.log_type=='module'?'olive':element.log_type=='quiz'?'teal':element.log_type=='group'?"grey":element.log_type=='course'?'dark-green':'navy-blue';
            element.icon = element.log_type=='module'?'mdi-book':element.log_type=='quiz'?'mdi-frequently-asked-questions':element.log_type=='group'?"mdi-account-group":element.log_type=='course'?'mdi-file':'mdi-account-supervisor';
        });
        log = sortmetadata(log);
        state.userlog = log
    },   
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }     
};

function sortmetadata(log){
    log.forEach(function (element) {
        const sortedMeta = new Object;
        let meta = element.meta_data;
        let Newarr = [];
        let SortPriorityArrayKeys = [];
        let keys = Object.keys(meta);
        let KeystoFilter=['Name','Description','permissions'];
        var fullMeta = {};
        KeystoFilter.forEach(function (SortList) {
            let filteredItem = keys.filter(item => item.includes(SortList));
            if(filteredItem.length>0){
                filteredItem.forEach(function (element) {
                    Newarr.push(element);
                    SortPriorityArrayKeys.push(element);
                });
            }
        });

        keys.forEach(function (key) {
            if(!Newarr.includes(key)){
                Newarr.push(key);
            }
        });

        Newarr.forEach(function (value) {
            sortedMeta[value] = meta[value];
        });

        element.meta_data = sortedMeta;

        var partMeta = {};
        var part1Meta = {};
        var part2Meta = {};
        var halfMeta = [];
        Object.keys(sortedMeta).forEach(v1 => {
            if(v1!="sendStatement"){
                if(sortedMeta[v1].length>20 || (typeof(sortedMeta[v1]) === 'object') || SortPriorityArrayKeys.includes(v1)){
                    //make a full length object
                    fullMeta[v1] = sortedMeta[v1];
                }
                else{
                    //make a part1 meta by dividing object into odd and even. But first remove full meta
                    partMeta[v1] = sortedMeta[v1];
                }
            }
        });

        element.full_meta_data = fullMeta;
        element.part_meta_data = partMeta;

        for (let i = 0; i < ((Object.keys(partMeta)).length); i++) {
            if(i%2==0){
                part1Meta[Object.keys(partMeta)[i]] = partMeta[Object.keys(partMeta)[i]];
            }
            else{
                part2Meta[Object.keys(partMeta)[i]] = partMeta[Object.keys(partMeta)[i]];
            }
        }

        element.part1_meta_data = part1Meta;
        element.part2_meta_data = part2Meta;

        for (let i = 0; i < ((Object.keys(part1Meta)).length); i++) {
            var valueToPush = { };
            valueToPush[Object.keys(part1Meta)[i]] = part1Meta[Object.keys(part1Meta)[i]];
            if(Object.keys(part2Meta)[i]!=undefined){
                valueToPush[Object.keys(part2Meta)[i]] = part2Meta[Object.keys(part2Meta)[i]];
            }
            halfMeta.push(valueToPush);
        }

        element.half_meta_data = halfMeta;

    });
    return log;
}

export default {
    state,
    getters,
    actions,
    mutations
};